export default __webpack_public_path__ + "static/media/tuvi.5f7b4162.png";